import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/HR';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/HR';
import { cardImage } from '../card-image/HR';
import { cardInsurance } from '../card-insurance/HR';
import { limitsChange } from '../card-limits-change/HR';
import { cardLimitsFocusPage } from '../card-limits-focus-page/HR';
import { limits } from '../card-limits/combined-limits/HR';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/HR';
import { permanentLimits } from '../card-limits/permanent-limits/HR';
import { temporaryLimits } from '../card-limits/temporary-limits/HR';
import { cardLockAndReplace } from '../card-lock-and-replace/HR';
import { cardLock } from '../card-lock/HR';
import { prepaidCardInfo } from '../card-prepaid-info/HR';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/HR';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/HR';
import { cardCancellation } from '../card-services/card-cancellation/HR';
import { cardDelivery } from '../card-services/card-delivery/HR';
import { changeCardDesign } from '../card-services/card-design-change/HR';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/HR';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/HR';
import { cardMigrationExternal } from '../card-services/card-migration-external/HR';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/HR';
import { cardReissue } from '../card-services/card-reissue/HR';
import { orderReplacementCard } from '../card-services/card-replacement/HR';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/HR';
import { changeCardDelivery } from '../card-services/delivery-management-v2/HR';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/HR';
import { changePinDelivery } from '../card-services/pin-delivery-change/HR';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/HR';
import { pinDelivery } from '../card-services/pin-delivery/HR';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/HR';
import { reprintPin } from '../card-services/reprint-pin/HR';
import { cardTracking } from '../card-tracking/HR';
import { cardUnlock } from '../card-unlock/HR';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/HR';
import { cardLimitInfo } from '../cards-bank/card-limit-info/HR';
import { cardReplacement } from '../cards-bank/card-replacement/HR';
import { geoControl } from '../cards-bank/geo-control/HR';
import { linkedAccounts } from '../cards-bank/linked-accounts/HR';
import { microCardActivation } from '../cards-bank/micro-card-activation/HR';
import { microSticker } from '../cards-bank/micro-sticker/HR';
import { cardServices } from '../cards-credit/additional-services/HR';
import { cardFees } from '../cards-credit/card-fees/HR';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/HR';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/HR';
import { creditCardMeter } from '../cards-credit/card-meter/HR';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/HR';
import { creditCardPayUp } from '../cards-credit/pay-up/HR';
import { autoRepayment } from '../cards-credit/repayment/HR';
import { creditCardStatements } from '../cards-credit/statements/HR';
import { contactlessPayments } from '../contactless-payments/HR';
import { expirationTime } from '../expiration-time/HR';
import { installmentsActivation } from '../installments-activation/HR';
import { installments } from '../installments/HR';
import { temporaryDeactivation } from '../temporary-deactivation/HR';
import { topUp } from '../top-up/HR';
import { upcomingInstallments } from '../upcoming-installments/HR';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: false,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: false,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: true,
    },
    nativeCardOrder: {
        enabled: false,
    },
    nativeCardReplacement: {
        enabled: false,
    },
};
